import { render, staticRenderFns } from "./OnlineFlex.vue?vue&type=template&id=4ef1e3a5&scoped=true&"
import script from "./OnlineFlex.vue?vue&type=script&lang=js&"
export * from "./OnlineFlex.vue?vue&type=script&lang=js&"
import style0 from "./OnlineFlex.vue?vue&type=style&index=0&id=4ef1e3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef1e3a5",
  null
  
)

export default component.exports